// extracted by css-extract-rspack-plugin
export default {"fullHeightAdminApp":"ws4V7sCDZ4FKv6DT__fullHeightAdminApp___"};